import { Chip, colorOrToken, Icons, tokens } from '@cast/design-system';

import { FEATURE_TO_TITLE } from 'hooks/dialogs/cluster/constants';

import {
  AgentSetupBlock,
  AgentSetupBlockProps,
} from './_components/AgentSetupBlock';
import { AgentSetupCompleteBlock } from './_components/AgentSetupCompleteBlock';
import FeatureLabel from './_components/FeatureLabel';

type SetupProps = Pick<
  AgentSetupBlockProps,
  'checked' | 'hasBeenInstalled' | 'readonly' | 'showCheckbox'
>;

type CompleteProps = {
  checked?: boolean;
};

const heading = FEATURE_TO_TITLE.costMonitoring;
const icon = <Icons.CastCostMonitoring variant="preset" weight="light" />;

export const AgentCostSetup = (props: SetupProps) => {
  return (
    <AgentSetupBlock
      heading={heading}
      description="Track and analyze your Kubernetes spending with detailed cost breakdowns and reports"
      icon={icon}
      labelChip={
        <>
          <Chip
            size="sm"
            startIcon={<Icons.Eye />}
            sx={{
              backgroundColor: colorOrToken(
                'green.50',
                tokens.theme.bg.status.successSubtle
              ),
              color: colorOrToken('green.600', tokens.theme.fg.status.success),
            }}
          >
            Read only
          </Chip>
          <FeatureLabel />
        </>
      }
      testId="agent-cost"
      {...props}
    />
  );
};

export const AgentCostComplete = ({ checked }: CompleteProps) => {
  return (
    <AgentSetupCompleteBlock
      heading={heading}
      icon={icon}
      testId="agent-cost-complete"
      checked={checked}
    />
  );
};
